<header>
    <div class="container-fluid">
        <nav class="navbar navbar-expand-lg">
            <div class="container-fluid">
                <a class="navbar-brand" routerLink="recipient">
                    <img src="assets/images/Sign_paperless_logo_default.svg" alt="logo" class="img-fluid">
                </a>
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                    aria-expanded="false" aria-label="Toggle
                   navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                        <li class="nav-item"><a class="nav-link" aria-current="page" routerLink="recipient"
                                [routerLinkActive]="['active']">Recipient</a></li>
                    </ul>
                    <div class="rightcontainer d-flex">
                        <div class="userprofile">
                            <div class="dropdown">
                                <button class="btn btn-secondary
                               dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    <img src="assets/images/user.png" alt="profile" class="img-fluid">
                                    <span class="username">
                                        <div class="profilegrid">Admin</div>
                                        <div class="namegrid">{{userName()}}<i class="fa-sharp fa-solid
                                     fa-sort-down"></i>
                                        </div>
                                    </span>
                                </button>
                                <ul class="dropdown-menu">
                                    <li>
                                        <a class="dropdown-item" href="javascript:void(0)"
                                            (click)="onLogout()">Logout</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    </div>
</header>